const initialState = {
  data: [],
  errors: {},
};

const insertCreatedPTO = (state, payload) => {
  const data = [...state.data];
  if (data.length > 0 && data[0].id === 'new') {
    data[0] = payload.pto;
  } else {
    data.unshift(payload.pto);
  }

  return data;
};

const handlePTOCreateErrors = (state, payload) => {
  const errPTO = { ...payload.pto, errors: payload.errors, id: 'new' };
  const data = [...state.data];

  if (data.length > 0 && data[0].id === 'new') {
    data[0] = errPTO;
  } else {
    data.unshift(errPTO);
  }

  return data;
};

const ptos = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PTO_INDEX_SUCCESS':
      return {
        ...state,
        data: payload.ptos,
      };
    case 'PTO_CREATE_SUCCESS':
      return {
        ...state,
        data: insertCreatedPTO(state, payload),
      };
    case 'PTO_UPDATE_SUCCESS':
      return {
        ...state,
        data: state.data.map(pto => (pto.id === payload.pto.id ? payload.pto : pto)),
      };
    case 'PTO_DELETE_SUCCESS':
      return {
        ...state,
        data: state.data.filter(pto => pto.id !== payload.ptoID),
      };
    case 'PTO_INDEX_FAILURE':
      return {
        ...state,
        errors: payload.errors,
      };
    case 'PTO_CREATE_FAILURE':
      return {
        ...state,
        data: handlePTOCreateErrors(state, payload),
      };
    case 'PTO_UPDATE_FAILURE':
    case 'PTO_DELETE_FAILURE':
      return {
        ...state,
        data: state.data.map(pto => (
          pto.id === payload.pto.id ? { ...payload.pto, errors: payload.errors } : pto)),
      };
    case 'PTO_INDEX_REQUEST':
    case 'PTO_CREATE_REQUEST':
    case 'PTO_UPDATE_REQUEST':
    case 'PTO_DELETE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default ptos;



// WEBPACK FOOTER //
// ./client/app/reducers/ptos.js